var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5567_1923)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20 20V76H76V31.32L64.68 20H20ZM48 72C41.36 72 36 66.64 36 60C36 53.36 41.36 48 48 48C54.64 48 60 53.36 60 60C60 66.64 54.64 72 48 72ZM60 40H24V24H60V40Z",
    fill: "#2B3E5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 12H20C15.56 12 12 15.6 12 20V76C12 80.4 15.56 84 20 84H76C80.4 84 84 80.4 84 76V28L68 12ZM76 76H20V20H64.68L76 31.32V76ZM48 48C41.36 48 36 53.36 36 60C36 66.64 41.36 72 48 72C54.64 72 60 66.64 60 60C60 53.36 54.64 48 48 48ZM24 24H60V40H24V24Z",
    fill: "#2B3E5B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 18,
    r: 21,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M74 9C70.265 9 68 11.8857 68 15.4286V24H80V15.4286C80 11.8857 77.735 9 74 9Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 30C75.5125 30 76.75 28.8 76.75 27.3333H71.25C71.25 28.8 72.4875 30 74 30ZM82.25 22V15.3333C82.25 11.24 80.0087 7.81333 76.0625 6.90667V6C76.0625 4.89333 75.1412 4 74 4C72.8588 4 71.9375 4.89333 71.9375 6V6.90667C68.005 7.81333 65.75 11.2267 65.75 15.3333V22L63 24.6667V26H85V24.6667L82.25 22ZM79.5 23.3333H68.5V15.3333C68.5 12.0267 70.5763 9.33333 74 9.33333C77.4237 9.33333 79.5 12.0267 79.5 15.3333V23.3333Z",
    fill: "#FFA000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5567_1923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.7768bc1d83e3489cf9e70d02c49fbc3e.svg";
export { ForwardRef as ReactComponent };